import React, { useState, useContext, useRef } from 'react';
import { NavbarContext } from '../../App';
import logo from '../../assets/img/logo.svg';
import { useSelector, useDispatch } from 'react-redux';
import hamburger from '../../assets/icons/hamburger.svg';
import Sidebar from './components/Sidebar';

import './Navbar.css';
import ProfileBox from './components/ProfileBox';
import NotificationBox from './components/NotificationBox';
import SearchIcon from '../../assets/icons/SearchIcon';
import CloseIcon from '../../assets/icons/CloseIcon';
import { logout } from '../../store/actions/authentication.action';
import Search from '../searchBar/Search';
import { fetchProjects } from '../../store/actions/projects/projects.action';
import NotificationIcon from '../../assets/icons/NotificationIcon';
import HelpIcon from '../../assets/icons/HelpIcon';
import { userNotifications } from '../../store/selectors/users/user.selector';

const Navbar = () => {
  const [showMobileNavbar, setMobileNabvar] = useState(false);
  const [showSearch, setShowSearch] = useState(false);
  const [showProfileBox, setShowProfileBox] = useState(false);
  const [showNotificationBox, setShowNotificationBox] = useState(false);
  const [searchValue, setSearchValue] = useState('');

  const searchRef = useRef(null);

  const dispatch = useDispatch();
  const { isAuthenticated, user } = useSelector((state) => state.auth);
  const notifications = useSelector(userNotifications());

  const onLogoutHandler = () => {
    dispatch(logout());
  };

  const { showLargeScreenNav, handleOpenLargeScreenNav } =
    useContext(NavbarContext);

  const handleOpenNavigationMenu = () => {
    setMobileNabvar(true);
  };

  const handleCloseNavigationMenu = () => {
    setMobileNabvar(false);
  };

  const handleSearch = () => {
    setShowSearch(true);
  };

  const handleShowProfileBox = () => {
    setShowProfileBox(!showProfileBox);
  };

  const handleShowNotificationBox = () => {
    setShowNotificationBox(!showNotificationBox);
  };

  const handleSearchChange = (e) => {
    setSearchValue(e.target.value);
  };

  const submitSearch = (e) => {
    e.preventDefault();
    setShowSearch(!showSearch);
    handleSetQueryString(searchValue);
  };

  const handleSetQueryString = (searchValue) => {
    var obj = {
      project_name_or_city: searchValue,
    };
    const queryString = Object.keys(obj)
      .map((key) => {
        if (obj[key]) {
          return `${key}=${obj[key]}`;
        }
      })
      .filter((key) => !!key)
      .join('&');
    dispatch(fetchProjects(queryString));
    return queryString;
  };

  function classNames(...classes) {
    return classes.filter(Boolean).join(' ');
  }

  let initials;
  if (user) {
    initials = `${user?.account.fname[0]}${user?.account?.lname[0]}`;
  }

  return (
    <div className="">
      <div
        className={classNames(
          showLargeScreenNav
            ? 'large-screen-side-bar-open'
            : 'large-screen-side-bar',
          'd-none d-lg-block'
        )}
      >
        <Sidebar
          openLargeSidebar={handleOpenLargeScreenNav}
          showLargeScreenNav={showLargeScreenNav}
        />
      </div>
      <div>
        <header className="d-flex bg-white justify-content-between py-2 py-md-4 text-13 align-items-lg-center navbar-header">
          <div
            className="w-sm-75 d-flex d-sm-flex d-lg-none wrapper__sidebar__header__hamburger"
            onClick={handleOpenNavigationMenu}
          >
            <img src={hamburger} alt="mmenu" />
          </div>
          <div className="d-none d-lg-flex ms-5 align-items-lg-center ">
            <div>
              <img src={logo} alt="logo" />
            </div>
            <div>
              <div className="ms-5 m-1">
                <form onSubmit={submitSearch} ref={searchRef}>
                  <Search
                    showSearchHandler={handleSearch}
                    activeSearch={showSearch}
                    searchValue={searchValue}
                    navBarSearch={true}
                    handleSearchChange={handleSearchChange}
                    fillColor="#AAAAAA"
                    customClassInput="form-control search-box-input text-black border-0"
                    placeHolder="Search in Sales Cloud"
                    globalSearch
                  />
                </form>
              </div>
            </div>
          </div>
          {/* <div className="w-sm-25 w-md-50 d-flex justify-content-end align-items-center">
            <div className="pt-2 mx-2 mx-md-4 d-none d-sm-none d-md-block">
              <div className="d-md-flex d-none text-primary body-text">
                Public feed
              </div>
            </div>
            <div className="">
              <NotificationBox
                title={
                  <div className="position-relative">
                    <div className="position-absolute text-10 bg-danger text-white notification-number">
                      {notifications.length}
                    </div>
                    <NotificationIcon fill="#AAAAAA" width="20" height="22" />
                  </div>
                }
                notifications={notifications}
                showNotificationBox={showNotificationBox}
                close={handleShowNotificationBox}
              />
            </div>
            <div className="mx-3 mx-md-6">
              <HelpIcon width="24" height="24" fill="#AAAAAA" />
            </div>
            <div className="py-2">
              <ProfileBox
                isAuthenticated={isAuthenticated}
                logoutHandler={onLogoutHandler}
                title={
                  <div
                    className="profile-icon text-uppercase rounded-circle bg-primary text-white fs-6 px-2 py-2"
                    onClick={handleShowProfileBox}
                  >
                    {initials}
                  </div>
                }
              />
            </div>
          </div> */}

          <div
            className={classNames(
              showMobileNavbar ? 'open-menu' : 'close-menu'
            )}
          >
            <div className="wrapper__menu__header align-items-center">
              <div className="wrapper__menu__header__img">
                <img src={logo} alt="logo" />
              </div>
              {/* <div
              className="wrapper__menu__header__close"
              onClick={handleCloseNavigationMenu}
            >
              <img src={closeIcon} alt="close" />
            </div> */}
              <div
                className="wrapper__menu__header__close"
                onClick={handleCloseNavigationMenu}
              >
                <CloseIcon
                  fill="white"
                  className="menu_close"
                  class="menu_close"
                  width="14"
                  height="14"
                  viewBox="0 0 14 14"
                />
              </div>
            </div>
            <div className="wrapper__menu__input">
              <div className="mx-4 position-relative">
                <input
                  type="text"
                  className="form-control"
                  placeholder="Search in Sales Cloud"
                />
                {/* <div className="icon">
                <img src={searchIcon} alt="search" />
              </div> */}

                <SearchIcon
                  fill="#BBBBBB"
                  width="20"
                  height="20"
                  className="icon"
                />
              </div>
            </div>

            <Sidebar />
          </div>
        </header>
      </div>
    </div>
  );
};

export default Navbar;
